module.exports = __webpack_public_path__ + "static/media/read_content_aloud_hin.7ae1d7a1.mp3";